<template>
  <div>
    <div style="visibility: hidden" id="printHere">
      <!-- <pre>{{dataPrint}}</pre> -->
      <!-- <div  id="printHere"> -->
      <vs-row id="center">
        <h6>
          {{ dataPrint.name }} #<a class="font-weight-bold">
            {{ dataPrint.id }}</a
          >
        </h6>
        <vs-spacer />
        <vs-button
          icon="share"
          id="btnShare"
          @click="printmodal()"
          color="rgba(9, 30, 66, 0.04)"
          type="filled"
          ><h6>Share</h6></vs-button
        >
      </vs-row>
      <vs-row class="mt-3" id="center">
        <h6 class="fontSizeData marginTop mr-1" id="center">
          <vs-tooltip
            text="This is the Asset this Task is assigned to."
            position="top"
          >
            <span id="allIcon" class="material-icons mr-1"> grid_view </span>
          </vs-tooltip>
          <span v-for="i in users" :key="i">
            <span class="mr-1 ml-1 aLocation">{{ i.name }}</span> >
          </span>
        </h6>
        <h6 class="mr-2 fontSizeData marginTop" id="center">
          <vs-tooltip
            text="This is Location this Task is assigned to."
            position="top"
          >
            <span id="allIcon" class="material-icons mr-1"> home </span>
          </vs-tooltip>
          {{ dataPrint.asset }}
        </h6>
        <h6 class="mr-2 fontSizeData marginTop" id="center">
          <vs-tooltip text="Who this Task is assigned to" position="top">
            <span id="allIcon" class="material-icons mr-1"> person </span>
          </vs-tooltip>
          {{ dataPrint.username }}
        </h6>
        <h6 class="mr-2 fontSizeData marginTop" id="center">
          <vs-tooltip text="The Due Date of this Task" position="top">
            <span id="allIcon" class="material-icons mr-1"> date_range </span>
          </vs-tooltip>
          {{ $moment(dataPrint.duedate).format("YYYY-MM-DD HH:mm:ss") }}
        </h6>
        <h6
          v-if="dataPrint.priority == '1 - Low priority'"
          class="mr-2 textSuccess fontSizeData marginTop"
          id="center"
        >
          <vs-tooltip text="The Priority of this Task" position="top">
            <span id="allIcon" class="material-icons mr-1"> error </span>
          </vs-tooltip>
          {{ dataPrint.priority }}
        </h6>
        <h6
          v-if="dataPrint.priority == '2 - Medium priority'"
          class="mr-2 fontSizeData marginTop textWarning"
          id="center"
        >
          <vs-tooltip text="The Priority of this Task" position="top">
            <span id="allIcon" class="material-icons mr-1"> error </span>
          </vs-tooltip>
          {{ dataPrint.priority }}
        </h6>
        <h6
          v-if="dataPrint.priority == '3 - High priority'"
          class="mr-2 fontSizeData marginTop textDanger"
          id="center"
        >
          <vs-tooltip text="The Priority of this Task" position="top">
            <span id="allIcon" class="material-icons mr-1"> error </span>
          </vs-tooltip>
          {{ dataPrint.priority }}
        </h6>
      </vs-row>
      <!-- <h6 class="mt-3 fontSizeData">Started by : {{ dataPrint.name }}</h6>
      <h6 class="mt-2 fontSizeData">
        Created date : {{ dataPrint.timestamp }}
      </h6>
      <h6 class="mt-2 fontSizeData">
        Last edited : {{ dataPrint.editdate }}
      </h6> -->
      <h6 class="mt-3 fontSizeData">
        Started By: <a class="boldWeightA"> Admin </a>
      </h6>
      <h6 class="mt-2 fontSizeData">
        Created Date:
        <a class="boldWeightA">
          {{ $moment(dataPrint.timestamp).format("LLLL") }}
        </a>
      </h6>
      <h6 class="mt-2 fontSizeData">
        Last Edited:
        <a class="boldWeightA">
          {{ $moment(dataPrint.editdate).format("LLLL") }}
        </a>
      </h6>
      <h6 class="mt-2 fontSizeData">
        Time Spent: <a class="boldWeightA">{{ dataPrint.timespent }} </a>
      </h6>
      <div style="padding: 0 20% 0 10%">
        <stepperWO :viewwork="dataPrint" />
        <!-- <stepperWO
        :viewwork="dataPrint"
        :actionResponse="getResponseST"
        :resCreated="resprintCreated"
        :resAcknowledged="resprintAcknowledged"
        :resSubmitted="resprintSubmitted"
        :resRejected="resprintRejected"
        :resDeclined="resprintDeclined"
        :resApproved="resprintApproved"
        :resCancelled="resprintCancelled"
      /> -->
      </div>

      <!-- <div v-if="dataPrint.iscomplete == 'Closed'" class="stepper-wrapper"  style="padding: 30px 50px 30px 10px; font-size: 10px">
        <div class="stepper-item completed">
          <div class="step-counter" style="color: #32c040">1</div>
          <div class="step-name">Created</div>
          <div>{{ dataPrint.username }}</div>
          <div>
            {{ $moment(dataPrint.timestamp).format("YYYY-MM-DD HH:mm:ss") }}
          </div>
        </div>
        <div class="stepper-item completed">
          <div class="step-counter" style="color: #32c040">2</div>
          <div class="step-name">Acknowledged</div>
          <div>{{ dataPrint.username }}</div>
          <div>
            {{ $moment(dataPrint.timestamp).format("YYYY-MM-DD HH:mm:ss") }}
          </div>
        </div>
        <div class="stepper-item active">
          <div class="step-counter" style="color: #ffffff">3</div>
          <div class="step-name" style="color: #32c040">Submitted</div>
          <div>{{ dataPrint.username }}</div>
          <div>
            {{ $moment(dataPrint.timestamp).format("YYYY-MM-DD HH:mm:ss") }}
          </div>
        </div>
        <div class="stepper-item inative">
          <div class="step-counter">4</div>
          <div class="step-name">Completed</div>
          <div>{{ dataPrint.username }}</div>
          <div>
            {{ $moment(dataPrint.timestamp).format("YYYY-MM-DD HH:mm:ss") }}
          </div>
        </div>
      </div> -->
      <vs-row class="mt-4" id="center">
        <h6 class="font-weight-bold fontSizeData">Instructions:</h6>
        <vs-spacer />
      </vs-row>
      <br />
      <div class="container">
        <vs-row class="mb-4">
          <vs-col vs-type="flex" vs-align="center" vs-w="6">
            <div class="input-box container-fluid">
              <span class="detail">Type</span>
              <vs-input
                readonly="true"
                class="selectVS mt-1"
                v-model="dataPrint.type"
              />
            </div>
          </vs-col>
          <vs-col vs-type="flex" vs-align="center" vs-w="6">
            <div class="input-box container-fluid">
              <span class="detail">Status</span>
              <vs-input
                readonly="true"
                class="selectVS mt-1"
                v-model="dataPrint.iscomplete"
              />
            </div>
          </vs-col>
        </vs-row>
        <vs-row class="mb-4">
          <vs-col vs-type="flex" vs-align="center" vs-w="6">
            <div class="input-box container-fluid">
              <span class="detail">WO Name</span>
              <vs-input
                readonly="true"
                class="selectVS mt-1"
                placeholder="Placeholder"
                v-model="dataPrint.name"
              />
            </div>
          </vs-col>
          <vs-col vs-type="flex" vs-align="center" vs-w="6">
            <div class="input-box container-fluid">
              <span class="detail">Priority</span>
              <vs-input
                readonly="true"
                class="selectVS mt-1"
                placeholder="Placeholder"
                v-model="dataPrint.priority"
              />
            </div>
          </vs-col>
        </vs-row>
        <vs-row class="mb-4">
          <vs-col vs-type="flex" vs-align="center" vs-w="6">
            <div class="input-box container-fluid">
              <span class="detail">#</span>
              <vs-input
                readonly="true"
                class="selectVS mt-1"
                placeholder="Placeholder"
                v-model="dataPrint.id"
              />
            </div>
          </vs-col>
          <vs-col vs-type="flex" vs-align="center" vs-w="6">
            <div class="input-box container-fluid">
              <span class="detail">Asset</span>
              <vs-input
                readonly="true"
                class="selectVS mt-1"
                placeholder="Placeholder"
                v-model="dataPrint.asset"
              />
            </div>
          </vs-col>
        </vs-row>
        <vs-row class="mb-4">
          <vs-col vs-type="flex" vs-align="center" vs-w="6">
            <div class="input-box container-fluid">
              <span class="detail">Assignee</span>
              <vs-input
                readonly="true"
                class="selectVS mt-1"
                placeholder="Placeholder"
                v-model="dataPrint.username"
              />
            </div>
          </vs-col>
          <vs-col vs-type="flex" vs-align="center" vs-w="6">
            <div class="input-box container-fluid">
              <span class="detail">E-mail</span>
              <vs-input
                readonly="true"
                class="selectVS mt-1"
                placeholder="Placeholder"
                v-model="dataPrint.email"
              />
            </div>
          </vs-col>
        </vs-row>
        <vs-row class="mb-4">
          <vs-col vs-type="flex" vs-align="center" vs-w="6">
            <div class="input-box container-fluid">
              <span class="detail">Start Date</span>
              <vs-input
                readonly="true"
                class="selectVS mt-1"
                placeholder="Placeholder"
                v-model="dataPrint.plandate"
              />
            </div>
          </vs-col>
          <vs-col vs-type="flex" vs-align="center" vs-w="6">
            <div class="input-box container-fluid">
              <span class="detail">Actual Start Date</span>
              <vs-input
                readonly="true"
                class="selectVS mt-1"
                placeholder="Placeholder"
                v-model="dataPrint.startdate"
              />
            </div>
          </vs-col>
        </vs-row>
        <vs-row class="mb-4">
          <vs-col vs-type="flex" vs-align="center" vs-w="6">
            <div class="input-box container-fluid">
              <span class="detail">Due Date</span>
              <vs-input
                readonly="true"
                class="selectVS mt-1"
                placeholder="Placeholder"
                v-model="dataPrint.duedate"
              />
            </div>
          </vs-col>
          <vs-col vs-type="flex" vs-align="center" vs-w="6">
            <div class="input-box container-fluid">
              <span class="detail">Actual End Date</span>
              <vs-input
                readonly="true"
                class="selectVS mt-1"
                placeholder="Placeholder"
                v-model="dataPrint.finishtime"
              />
            </div>
          </vs-col>
        </vs-row>

        <vs-row class="mb-4">
          <vs-col vs-type="flex" vs-align="center" vs-w="12">
            <div class="input-box container-fluid">
              <span class="detail">Instructions</span><br />
              <span class="textAreaBox mt-2">{{ dataPrint.detail }}</span>
            </div>
          </vs-col>
        </vs-row>

        <vs-row class="mb-4">
          <vs-col vs-type="flex" vs-align="center" vs-w="12">
            <div class="input-box container-fluid">
              <span class="detail">Completion Notes</span>
              <vs-textarea class="widthTextArea" v-model="textarea" />
              <vs-button
                icon="done"
                size="small"
                @click="complete"
                class="rounded-pill"
                color="success"
                type="filled"
                >Complete</vs-button
              >
            </div>
          </vs-col>
        </vs-row>
      </div>
    </div>
  </div>
</template>

<script>
import stepperWO from "../stepperWO.vue";
import { Window } from "dhx-suite";
export default {
  props: ["dataPrint"],
  components: {
    stepperWO,
  },
  data: () => ({
    dataPrint: [],
    sensorlist: [],
    name: "",
     users: [
      {
        id: 1,
        name: "Leanne Graham",
        username: "Bret",
        email: "Sincere@april.biz",
        website: "hildegard.org",
      },
      {
        id: 2,
        name: "Ervin Howell",
        username: "Antonette",
        email: "Shanna@melissa.tv",
        website: "anastasia.net",
      },
      {
        id: 3,
        name: "Clementine Bauch",
        username: "Samantha",
        email: "Nathan@yesenia.net",
        website: "ramiro.info",
      },
    ],
  }),
  methods: {
    printmodal() {
      const modal = document.getElementById("printHere");
      const cloned = modal.cloneNode(true);
      let section = document.getElementById("print");

      if (!section) {
        section = document.createElement("div");
        section.id = "print";
        document.body.appendChild(section);
      }

      section.innerHTML = "";
      section.appendChild(cloned);
      window.print();
      return false;
    },
  },
  mounted() {
    // console.log(dataPrint.id);
    //dataPrint[0].id
    // });

    this.dataPrint = [];
    this.dataPrint = this.$session.get("dataPrint");
// this.b = this.$session.get("b");
//     console.log(this.b)

    this.$vs.loading({ text: "Loading for print" });
    setTimeout(() => {
      this.$vs.loading.close();
      const modal = document.getElementById("printHere");
      const cloned = modal.cloneNode(true);
      let section = document.getElementById("print");

      if (!section) {
        section = document.createElement("div");
        section.id = "print";
        document.body.appendChild(section);
      }

      section.innerHTML = "";
      section.appendChild(cloned);
      window.print();
      location.reload();
      this.$router.back();
    }, 1);
  },
};
</script>
<style >
@media screen {
  #print {
    display: none;
  }
}

@media print {
  @page {
    size: portrait;
  }
  body * {
    visibility: hidden;
  }
  #print,
  #print * {
    visibility: visible;
  }
  #print {
    position: absolute;
    left: 0;
    top: 2.5%;
    -webkit-print-color-adjust: exact !important;
  }
}
</style>
<style scoped>
.textAreaBox {
  display: block;
  width: 89%;
  border-radius: 6px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  color: rgba(0, 0, 0, 0.8);
  padding: 9px;
  overflow: hidden;
  min-height: 40px;
  line-height: 20px;
}
.selectVS {
  width: 75%;
  font-size: 0.75rem;
}
.widthTextArea {
  width: 95%;
}
.detail {
  font-size: 0.75rem;
  font-weight: 100;
}
</style>